import {isEqual} from 'lodash';
import {useMemo} from 'react';

import {usePartMaybe, useParts} from '../../../state/views/hooks';
import type {
  PanelBankSectionConfigNormalized as SectionPart,
  Ref as SectionRef,
} from '../../../state/views/panelBankSectionConfig/types';
import {PANEL_BANK_HIDDEN_SECTION_NAME} from '../../../util/panelbankTypes';
import {usePanelsSharedRefsContext} from '../../Views/contexts/PanelsSharedRefsContext';
import {usePanelContext} from '../PanelContextProvider';

/** Returns list of sections where you could move a panel to */
export const useSectionsForMovePanel = () => {
  const {panelBankConfigRef} = usePanelsSharedRefsContext();
  const {panelBankSectionConfigRef: currentSectionRef} = usePanelContext();
  const sectionRefsMaybe = usePartMaybe(panelBankConfigRef)?.sectionRefs;
  const sectionRefs = useMemo(() => sectionRefsMaybe ?? [], [sectionRefsMaybe]);
  const sectionParts = useParts(sectionRefs);

  return useMemo(() => {
    return sectionRefs.reduce(
      (acc, ref, idx) => {
        const part = sectionParts[idx];
        const isCurrentSection = isEqual(ref, currentSectionRef);
        const isHiddenSection =
          idx === sectionRefs.length - 1 &&
          part.name === PANEL_BANK_HIDDEN_SECTION_NAME;

        if (isCurrentSection || isHiddenSection) {
          return acc;
        }

        acc.push({ref, part});
        return acc;
      },
      [] as Array<{ref: SectionRef; part: SectionPart}>
    );
  }, [currentSectionRef, sectionParts, sectionRefs]);
};
